(() => {
  'use strict';

  // Full storefront search only: leave autocomplete and app/section requests alone.
  const isSearch = url =>
    /\/search\/?$/.test(url.pathname) &&
    !url.searchParams.has('view') &&
    !url.searchParams.has('section_id');

  function isAlreadyQualified(value) {
    const term = String.raw`(?:\\.|[^\\\s()])+`;
    const group = String.raw`\(\s*title:${term}\*\s+OR\s+tag:${term}\*\s*\)`;
    return new RegExp(`^${group}(?:\\s+${group})*$`).test(value.trim());
  }

  function escapeTerm(text) {
    return text
      .replace(/[\\:()"*]/g, '\\$&')
      .replace(/^-/, '\\-');
  }

  function normalize(value) {
    const trimmed = value.trim();

    // Prevent an already-generated query from being processed again.
    if (isAlreadyQualified(trimmed)) {
      return trimmed;
    }

    const words = trimmed.split(/\s+/).filter(Boolean);

    return words
      .map(word => {
        const term = escapeTerm(word);
        return `(title:${term}* OR tag:${term}*)`;
      })
      .join(' ');
  }
function displayQuery(value) {
  return value
    .replace(/\(\s*title:((?:\\.|[^\\*])+)\*\s+OR\s+tag:(?:\\.|[^\\*])+\*\s*\)/gi, '$1')
    .replace(/\\(.)/g, '$1')
    .trim();
}
  const current = new URL(location.href);

  if (isSearch(current) && current.searchParams.has('q')) {
    const query = normalize(current.searchParams.get('q'));

    if (
      current.searchParams.get('q') !== query ||
      current.searchParams.get('type') !== 'product'
    ) {
      current.searchParams.set('q', query);
      current.searchParams.set('type', 'product');
      location.replace(current.href);
      return;
    }
  }
document.querySelectorAll('form[data-title-search] input[name="q"]').forEach(input => {
  input.value = displayQuery(current.searchParams.get('q') || input.value);
});
  document.addEventListener('submit', event => {
    const form = event.target;

    if (!form.matches('form[data-title-search]')) return;

    const url = new URL(form.action, location.href);

    if (url.origin !== location.origin || !isSearch(url)) return;

    const data = new FormData(form);

    data.set('q', normalize(String(data.get('q') || '')));
    data.set('type', 'product');

    url.search = new URLSearchParams(data).toString();

    // Retain a locally selected theme preview when explicitly present.
    if (current.searchParams.has('preview_theme_id')) {
      url.searchParams.set(
        'preview_theme_id',
        current.searchParams.get('preview_theme_id')
      );
    }

    event.preventDefault();
    location.assign(url.href);
  });
})();
